import Show from '../show'

function UbAccountsDashboard() {
  return (
    <Show
      title="Utility Billing — Accounts Dashboard"
      dashboardKey="ub_accounts_dashboards"
      showYear={false}
    />
  )
}

export default UbAccountsDashboard
